import { render, staticRenderFns } from "./AprovacaoSolicitacaoItem.vue?vue&type=template&id=ed61774a&"
import script from "./AprovacaoSolicitacaoItem.vue?vue&type=script&lang=js&"
export * from "./AprovacaoSolicitacaoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VSubheader})
